import { get } from '@/api/base'

const categoryValuesApi = {
  get: async (context, category) => {
    const response = await get({
      path: `category_values/${context}/${category}`,
    })
    return response.success ? response.data.category_values : []
  },
}

export default categoryValuesApi
